var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationListIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 3.96154C8.94537 3.96154 6.95 5.98903 6.95 8.375C6.95 9.07092 7.18983 9.95983 7.68105 10.9969C8.16305 12.0145 8.8276 13.0511 9.5318 14.0075C10.2365 14.9646 10.9505 15.8007 11.5 16.4089C12.0495 15.8007 12.7635 14.9646 13.4682 14.0075C14.1724 13.0511 14.8369 12.0145 15.3189 10.9969C15.8102 9.95983 16.05 9.07092 16.05 8.375C16.05 5.98903 14.0546 3.96154 11.5 3.96154ZM11.1165 18.8449C10.8673 18.5994 5 12.7939 5 8.375C5 4.85919 7.91525 2 11.5 2C15.0848 2 18 4.85919 18 8.375C18 12.7939 12.1327 18.5994 11.8835 18.8449C11.7773 18.9479 11.6387 19 11.5 19C11.3613 19 11.2227 18.9479 11.1165 18.8449Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 21.5086C10 20.6686 10.6404 20 11.5 20C12.3596 20 13 20.6686 13 21.4914V21.5086C13 22.3314 12.3596 23 11.4831 23C10.6404 22.9829 10 22.3143 10 21.5086Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationListIcon);
export default __webpack_public_path__ + "static/media/locationListIcon.822047e6cac7924644f39f5963856b8a.svg";
export { ForwardRef as ReactComponent };